var TLS_DEBUG = $('body').hasClass('dev');

$(document).ready(function () {

    function autocomplete_fillInAddress(input_id_city, input_id_region, input_id_lat, input_id_lng, autocomplete) {

        var place = autocomplete.getPlace();
        var address_components = place.address_components;
        var suburb = '';
        var city = '';
        var region = '';
        var address_lat = '';
        var address_lng = '';

        if (TLS_DEBUG) { console.group('Google AutoComplete API - Call Back...'); }

        if (TLS_DEBUG) { console.log(address_components); }

        $.each(address_components, function(index, component){
            var types = component.types;
            jQuery.each(types, function(index, type){

                if(type == 'sublocality_level_1') {
                    suburb = component.long_name;
                }
                if(type == 'locality') {
                    city = component.long_name;
                }
                if(type == 'administrative_area_level_1') {
                    region = component.long_name;
                }
            });
        });

        if (region == 'Auckland') {
            if (suburb == '') {
                suburb = city;
                city = region;
            } else {
                city = region;
            }
        }

        if (TLS_DEBUG) { console.log('Suburb         : ' + suburb); }
        if (TLS_DEBUG) { console.log('City           : ' + city); }
        if (TLS_DEBUG) { console.log('Region         : ' + region); }

        var geocoder;
        geocoder = new google.maps.Geocoder();

        // Retrieve Latitude/Longitude
        geocoder.geocode({ 'placeId': place.place_id }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                address_lat = results[0].geometry.location.lat();
                address_lng = results[0].geometry.location.lng();

                $('.' + input_id_lat).val(address_lat);
                $('.' + input_id_lng).val(address_lng);

                if (TLS_DEBUG) { console.group('Google Geocoder API - Call Back...'); }
                if (TLS_DEBUG) { console.log('Lat : ' + address_lat); }
                if (TLS_DEBUG) { console.log('Lat : ' + address_lng); }
                if (TLS_DEBUG) { console.groupEnd(); }
            }
        });

        if (TLS_DEBUG) { console.groupEnd(); }

        $('.' + input_id_city).val(city);
        $('.' + input_id_region).val(region);

    }

    function autocomplete_city_init() {
        var autocomplete_city;
        var autocomplete_city_options = {
            componentRestrictions: {'country':'nz'},
        };
        var autocomplete_input_city = document.getElementsByClassName("ac_input_city")[0];

        if (TLS_DEBUG) { console.group('Google AutoComplete API...'); }

        if (autocomplete_input_city != null) {
            if (TLS_DEBUG) { console.log('Listener - input_city : OK'); }
            autocomplete_city = new google.maps.places.Autocomplete(autocomplete_input_city, autocomplete_city_options);
            autocomplete_city.addListener('place_changed', function() { autocomplete_fillInAddress('ac_city','ac_region','ac_lat','ac_lng',autocomplete_city)});
        } else {
            if (TLS_DEBUG) { console.log('Listener - input_city : Not Found'); }
        }

        if (TLS_DEBUG) { console.groupEnd(); }
    }

    autocomplete_city_init();

    $('#g-recaptcha-response').each(function() {
        var $this = $(this);
        grecaptcha.ready(function() {
            grecaptcha.execute('6LfOBp0UAAAAAJK3onMePCsGuc1n5eK-uDy2yfhB', {action: 'shecancode'}).then(function(token) {

                if (TLS_DEBUG) { console.group('Google reCAPTCHA v3 API...'); }
                if (TLS_DEBUG) { console.log('reCAPTCHA Token : ' + token); }
                if (TLS_DEBUG) { console.groupEnd(); }
                $this.val(token)
            })
        })
    });

});